//-----------------------------\\
//--- Transition avec barba ---\\
//-----------------------------\\

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// C'est ici que les transition entre les page sont gérées, on y retrouve les différentes views spécifiques à
// chaque page. Tout commence avec la fonction doOnce.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import Barba from 'barba.js'
import $ from 'jquery'
import { setView } from './views.js'
//-----------------------------------------------------------------------------------------------------------------


// Cette fonction Gère la transition entre les page
export function initPageTransition() {
  Barba.Pjax.cacheEnabled = false
  Barba.Pjax.Dom.wrapperId = 'transition-wrapper'
  Barba.Pjax.Dom.containerClass = 'transition-container'
  Barba.Pjax.ignoreClassLink = 'no-transition'
  Barba.Dispatcher.on('initStateChange', function(currentStatus) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'PageTracked',
      'pagePath': location.pathname,
    })
  })
  Barba.Dispatcher.on('initStateChange', function (currentStatus) {
    if( typeof gtag === 'function' ) gtag('config', 'UA-150959240-14', { 'page_path': location.pathname }) // Google tag
  })
  setTransition()
  setView()
  Barba.Pjax.start()
}


// Cette fonctions exécute la transition entre les pages
function setTransition() {
  var FadeTransition = Barba.BaseTransition.extend({
    start: function() {
      Promise
        .all([this.newContainerLoading, this.fadeOut()])
        .then(this.fadeIn.bind(this))
    },
    fadeOut: function() {
      return $('html').addClass('transition').delay(1000).promise()
    },
    fadeIn: function() {
      if (!window.location.hash) $(document).scrollTop(0)
      $('html').addClass('closing').removeClass('transition').delay(1000).queue(function(next){
        $(this).removeClass('closing')
        next()
      })
      this.done()
    }
  })

  Barba.Pjax.getTransition = function() {
    return FadeTransition
  }
}

// Execution du code dans le container de la transition barba.
Barba.Dispatcher.on('transitionCompleted', function() {
  var js = $('.content script.dynjs').html()
  if(js) eval(js)
})
